import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { apiService } from "../../services/apiService";
import {
  addCandidate,
  clearAllCandidates,
} from "../../../../store/steps/stepFiveSlice";
import useDataFetch, {
  DataFetchOptionsType,
} from "../../../../hooks/useDataFetch";
import { useDispatch } from "react-redux";
import RenderData from "./partials/renderData";
import RenderLoading from "./partials/renderLoading";
import RenderError from "./partials/renderError";

const StepFive = () => {
  const dispatch = useDispatch();
  const { assessmentId } = useParams();
  const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({
    req: {
      assessmentId,
      page: 1,
      limit: 10,
    },
  });
  const { loading, data, error } = useDataFetch(
    apiService.getCandidates,
    fetchOptions
  );

  useEffect(() => {
    if (data) {
      dispatch(clearAllCandidates());
      const users = data.assessments;
      users.forEach((user) => {
        dispatch(addCandidate({ name: user.name, email: user.email }));
      });
    }
  }, [data]);

  if (error) {
    return <RenderError />;
  }

  if (loading) {
    return <RenderLoading />;
  }

  return <RenderData hasMore={data.hasMoreResults} />;
};

export default StepFive;
